// crypto-js 密匙
export const cryptoKey = 'y343XBlI32452dfgi343565NTYiLCJ0eX757535V1Qif'
